/**
 * CV Health rings: one geometry for the native SVG (`HealthRings.tsx`) and the
 * web SVG (`HealthRings.web.tsx`), so the two can never drift.
 *
 * The geometry itself lives in `@tabbio/utils/cv-health-view`, shared with the
 * public CV Health page on cvhealth.tabbio.com (apps/web), so the app and the
 * site draw identical rings. This module keeps the app's import path and
 * public names stable.
 *
 * Three thin concentric rounded rings on the Amicro radial gauge proportions:
 * an 8-unit stroke at the 168 px reference size, scaled with the size and
 * never thinner than 6 px, with three quarters of a stroke between rings.
 * Outer ring = Recruiters (human), middle = Hiring systems (system), inner =
 * AI tools (ai_bot). Pure module: no React, no platform code.
 */
export {
  HEALTH_RING_ANIMATION_MS,
  HEALTH_RING_CENTER_FONT_RATIO,
  HEALTH_RING_COLOR_KEYS,
  HEALTH_RING_COUNT,
  HEALTH_RING_CSS_VARS,
  HEALTH_RING_EASING,
  HEALTH_RING_GAP_RATIO,
  HEALTH_RING_MIN_STROKE,
  HEALTH_RING_MIN_VISIBLE_FRACTION,
  HEALTH_RING_REFERENCE_SIZE,
  HEALTH_RING_STROKE,
  clampFraction,
  describeRing,
  describeRings,
  getRingStroke,
  ringArcOpacity,
  ringDashOffset,
  ringStartTransform,
  type HealthRingColorKey,
  type HealthRingGeometry,
  type HealthRingsLayout,
} from '@tabbio/utils/cv-health-view';
